import { FastlyImage } from '@components/common/image'
import {
  ANDROID_APP_PLAY_STORE_LINK,
  ANDROID_APP_QR_CODE_IMAGE,
} from '@lib/constants/common'
import { Trans } from '@lingui/macro'
import { Smartphone } from 'react-feather'

type Props = {
  className?: string
  isFooter?: boolean
}

const AppDownloadCard = ({ className = '', isFooter = false }: Props) => (
  <div
    className={`${
      isFooter ? 'mt-5' : 'p-5 lg:p-8 rounded-lg shadow-sm'
    } relative  ${className}`}
    style={{
      background: !isFooter
        ? 'linear-gradient(120deg, #FFEDEB 0%, #FFF6F5 35%, #FFEED0 70%, #F7F2FE 100%)'
        : 'none',
    }}
  >
    <div className="relative flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
      <div className="flex-1">
        {!isFooter && (
          <div className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-xs font-600 text-orange shadow-sm">
            <Smartphone size={12} />
            <Trans>Now on Android</Trans>
          </div>
        )}
        <h3 className="mt-3 text-xl lg:text-2xl  font-600 leading-tight text-grey">
          <Trans>Get the Codingal app</Trans>
        </h3>
        <p className={`mt-2 text-grey`}>
          <Trans>
            Book classes, track your child&apos;s progress, and chat with our
            support team — right from your phone.
          </Trans>
        </p>

        <a
          href={ANDROID_APP_PLAY_STORE_LINK}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download the Codingal Android app on Google Play"
          className="mt-5 inline-block focus:outline-none"
        >
          <FastlyImage
            src="/images/icons/google-play-badge.png"
            webpSrc="/images/icons/google-play-badge.webp"
            height={40}
            width={130}
            alt="Get it on Google Play"
          />
        </a>
      </div>

      <div className="hidden flex-shrink-0 flex-col items-center sm:flex">
        <div className="rounded-xl bg-white p-3 shadow-sm ring-1 ring-grey-200">
          <FastlyImage
            src={ANDROID_APP_QR_CODE_IMAGE}
            height={135}
            width={135}
            alt="Scan the QR code to download the Codingal Android app"
          />
        </div>
        <p className="mt-2 text-sm text-grey-800 font-600">
          <Trans>Scan to download</Trans>
        </p>
      </div>
    </div>
  </div>
)

export default AppDownloadCard
